import "./App.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
// import Gallery from "./components/gallery";
import Team from "./components/Team";
import TechTeam from "./components/TechTeam";
import Members from "./components/Join";
import Join from "./components/TechXperience";
import ComingSoon from "./components/ComingSoon";
import Dashboard from './components/Dashboard';
import AudiencePollPage from './components/AudiencePollPage';
import AudiencePollResultsPage from './components/AudiencePollResultsPage';
import Verify from './components/Verify';
import Login from './components/Login';
import JoiningRegSheet from './components/JoiningRegSheet';
import CancellationRefunds from './components/CancellationRefunds';
import TermsConditions from './components/TermsConditions';
import Shipping from './components/Shipping';
import Privacy from './components/Privacy';
import pb from './lib/pocketbase';
import ScratchLabsRegistration from "./components/ScratchLabsRegistration";
import ScratchLabsParticipantDashboard from "./components/ScratchLabsParticipantDashboard";
import AITribunalRegistration from "./components/AITribunalRegistration";
import ScratchLabsMarketingLinksForm from "./components/ScratchLabsMarketingLinksForm";
import RegistrationSlider from "./components/RegistrationSlider/RegistrationSlider";
import OrientationRegistration from "./components/OrientationRegistration/OrientationRegistration";
import MemberIdCard from "./components/MemberIdCard";

function AppContent() {
  const [auth, setAuth] = React.useState(pb.authStore.isValid);
  const [resultsRouteUnlocked, setResultsRouteUnlocked] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    const unsubscribe = pb.authStore.onChange(() => {
      setAuth(pb.authStore.isValid);
      if (!pb.authStore.isValid) {
        setResultsRouteUnlocked(false);
      }
    });

    return unsubscribe;
  }, []);

  const hideHeaderPaths = [
    '/scratchlabs',
    '/scratchlabs/participant-portal',
    '/scratchlabs/marketing-links',
    '/ai-tribunal',
    '/registrations',
    '/verify',
    '/scratchlabs/audience-poll',
    '/scratchlabs/audience-poll/results',
    '/data-export',
    '/joining-registrations',
    '/cancellation-refunds',
    '/workshop',
    '/terms-conditions',
    '/shipping',
    '/privacy',
    '/register',
  ];

  const shouldHideHeader =
    hideHeaderPaths.includes(location.pathname) ||
    location.pathname.startsWith('/member');

  const showQueryBar = hideHeaderPaths.includes(location.pathname);

  return (
    <>
      {!shouldHideHeader && <Header />}
      <Routes>
        <Route path="/audience-poll" element={<Navigate to="/scratchlabs/audience-poll" replace />} />
        <Route path="/workshop" element={<RegistrationSlider />} />
        <Route path="/TechTeam" element={<TechTeam />} />
        <Route path="/Members" element={<Members />} />
        <Route path="/member/:id" element={<MemberIdCard />} />
        <Route path="/members/:id" element={<MemberIdCard />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/gallery" element={<Gallery />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/team" element={<Team />} />
        <Route path="/join" element={<Join />} />
        <Route path="/register" element={<OrientationRegistration />} />
        <Route path="/scratchlabs" element={<ScratchLabsRegistration />} />
        <Route path="/scratchlabs/participant-portal" element={<ScratchLabsParticipantDashboard />} />
        <Route path="/scratchlabs/marketing-links" element={<ScratchLabsMarketingLinksForm />} />
        <Route path="/ai-tribunal" element={<AITribunalRegistration />} />
        <Route path="/registrations" element={auth ? <Dashboard /> : <Login onLogin={() => setAuth(true)} />} />
        <Route path="/joining-registrations" element={auth ? <JoiningRegSheet /> : <Login onLogin={() => setAuth(true)} />} />
        <Route path="/verify" element={auth ? <Verify /> : <Login onLogin={() => setAuth(true)} />} />
        <Route path="/comingsoon" element={<ComingSoon />} />
        <Route path="/scratchlabs/audience-poll" element={<AudiencePollPage />} />

        <Route
          path="/scratchlabs/audience-poll/results"
          element={auth && resultsRouteUnlocked ? <AudiencePollResultsPage /> : <Login onLogin={() => {
            setAuth(true);
            setResultsRouteUnlocked(true);
          }} />}
        />
        <Route path="/cancellation-refunds" element={<CancellationRefunds />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/shipping" element={<Shipping />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>

      {showQueryBar && (
        <div className="global-query-bar" role="contentinfo" aria-label="Query contact details">
          <span>For any queries or question contact </span>
          <span className="global-query-team-contact">
            <span className="global-query-label">@IEC Technical Team :</span>
            <a href="tel:+917004577714" className="global-query-phone">+91 70045 77714</a>
          </span>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;